// extracted by mini-css-extract-plugin
export default {"FAQContainer":"SupportFAQ_FAQContainer__JVdMt","FAQEntries":"SupportFAQ_FAQEntries__dZrDK"};